// frontend/src/pages/NotificationsPage.jsx
import React from 'react';
import NotificationsList from '../../components/notifications/NotificationsList';
import { Helmet } from '@dr.pogodin/react-helmet';

const NotificationsPage = () => {
  return (
    <>
      <Helmet>
        <title>Notifications | MediGo</title>
        <meta name="description" content="View and manage your MediGo notifications" />
      </Helmet>
      
      <NotificationsList />
    </>
  );
};

export default NotificationsPage;